import { render } from "./Bookmark.vue?vue&type=template&id=26b8d96a&scoped=true"
import script from "./Bookmark.vue?vue&type=script&lang=js"
export * from "./Bookmark.vue?vue&type=script&lang=js"

import "./Bookmark.vue?vue&type=style&index=0&id=26b8d96a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src827224769/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b8d96a"]])

export default __exports__